import UnoGameState from '../logic/uno/GameState';
import UnoDeck from '../logic/uno/Deck';
import UnoPlayer from '../logic/uno/Player';
import UnoCard from '../logic/uno/Card';
import UnoNMGameState from '../logic/uno-nm/GameState';
import UnoNMDeck from '../logic/uno-nm/Deck';
import UnoNMPlayer from '../logic/uno-nm/Player';
import UnoNMCard from '../logic/uno-nm/Card';

const serializeCard = (card) => ({
    color: card?.color ?? null,
    value: card?.value ?? null,
    card_type: card?.card_type ?? null
});

const hydrateCards = (cards, CardClass) => (cards || []).map((card) =>
    Object.assign(Object.create(CardClass.prototype), serializeCard(card))
);

const hydratePlayers = (players, PlayerClass, CardClass) => (players || []).map((player) => {
    const hydrated = Object.assign(Object.create(PlayerClass.prototype), {
        ...player,
        hand: hydrateCards(player?.hand || [], CardClass)
    });
    return hydrated;
});

const hydrateDeck = (deckSnapshot, DeckClass, CardClass) => {
    const hydratedDeck = Object.assign(Object.create(DeckClass.prototype), {
        ...(deckSnapshot || {})
    });
    hydratedDeck.cards = hydrateCards(deckSnapshot?.cards || [], CardClass);
    return hydratedDeck;
};

export const serializeUnoGameState = (game) => {
    if (!game) return null;

    return {
        players: (game.players || []).map((player) => ({
            name: player.name,
            isHuman: Boolean(player.isHuman),
            hand: (player.hand || []).map(serializeCard)
        })),
        deck: {
            cards: (game.deck?.cards || []).map(serializeCard)
        },
        discardPile: (game.discardPile || []).map(serializeCard),
        direction: game.direction,
        currentPlayerIndex: game.currentPlayerIndex,
        currentColor: game.currentColor
    };
};

export const hydrateUnoGameState = (snapshot) => {
    if (!snapshot) return null;

    const hydrated = Object.assign(Object.create(UnoGameState.prototype), {
        direction: snapshot.direction,
        currentPlayerIndex: snapshot.currentPlayerIndex,
        currentColor: snapshot.currentColor
    });
    hydrated.players = hydratePlayers(snapshot.players, UnoPlayer, UnoCard);
    hydrated.deck = hydrateDeck(snapshot.deck, UnoDeck, UnoCard);
    hydrated.discardPile = hydrateCards(snapshot.discardPile, UnoCard);
    return hydrated;
};

export const serializeUnoNmGameState = (game) => {
    if (!game) return null;

    return {
        players: (game.players || []).map((player) => ({
            name: player.name,
            isHuman: Boolean(player.isHuman),
            isEliminated: Boolean(player.isEliminated),
            hand: (player.hand || []).map(serializeCard)
        })),
        deck: {
            cards: (game.deck?.cards || []).map(serializeCard)
        },
        discardPile: (game.discardPile || []).map(serializeCard),
        direction: game.direction,
        currentPlayerIndex: game.currentPlayerIndex,
        currentColor: game.currentColor,
        stackedDrawCount: game.stackedDrawCount,
        isStacking: Boolean(game.isStacking),
        rouletteActive: Boolean(game.rouletteActive)
    };
};

export const hydrateUnoNmGameState = (snapshot) => {
    if (!snapshot) return null;

    const hydrated = Object.assign(Object.create(UnoNMGameState.prototype), {
        direction: snapshot.direction,
        currentPlayerIndex: snapshot.currentPlayerIndex,
        currentColor: snapshot.currentColor,
        stackedDrawCount: snapshot.stackedDrawCount || 0,
        isStacking: Boolean(snapshot.isStacking),
        rouletteActive: Boolean(snapshot.rouletteActive)
    });
    hydrated.players = hydratePlayers(snapshot.players, UnoNMPlayer, UnoNMCard);
    hydrated.deck = hydrateDeck(snapshot.deck, UnoNMDeck, UnoNMCard);
    hydrated.discardPile = hydrateCards(snapshot.discardPile, UnoNMCard);
    return hydrated;
};
